import React, { Component } from 'react';
import {GeckoCardHeader} from '../';

class GeckoLogoHeader extends Component {
    render() {
        return (
            <GeckoCardHeader>
                <div className="header-logo">
                    <img src="/images/gecko.svg" alt="Gecko Logo" />
                </div>
            </GeckoCardHeader>
        );
    }
}

export default GeckoLogoHeader;